import { useCallback } from 'react';
import { API } from '../App';
import axios from 'axios';
import { toast } from 'sonner';

/**
 * useLayoutManager - Layout kaydet/yükle mantığını içeren hook
 */
export function useLayoutManager({
  exhibition,
  hall,
  gridWidth,
  gridHeight,
  gridData,
  setGridData,
  setGridWidth,
  setGridHeight,
  setLayoutLoaded,
  setLayoutExistsOnServer,
  layoutExistsOnServer,
}) {
  const initializeGrid = useCallback((width, height) => {
    const newGrid = [];
    for (let y = 0; y < height; y++) {
      const row = [];
      for (let x = 0; x < width; x++) {
        const isBoundary = x === 0 || x === width - 1 || y === 0 || y === height - 1;
        row.push({ type: isBoundary ? 'corridor' : 'empty', assignedTo: null });
      }
      newGrid.push(row);
    }
    setGridData(newGrid);
    setLayoutLoaded(true);
  }, [setGridData, setLayoutLoaded]);

  const loadLayout = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const layoutId = hall ? `${exhibition.id}_${hall.id}` : exhibition.id;
      const res = await axios.get(`${API}/layouts/${layoutId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setGridWidth(res.data.grid_width);
      setGridHeight(res.data.grid_height);
      setGridData(res.data.grid_data);
      setLayoutLoaded(true);
      setLayoutExistsOnServer(true);
    } catch (error) {
      if (error.response?.status === 404) {
        const width = hall ? Math.ceil(hall.width_meters) : gridWidth;
        const height = hall ? Math.ceil(hall.length_meters) : gridHeight;
        initializeGrid(width, height);
      } else {
        toast.error('Kroki yüklenemedi');
      }
    }
  }, [exhibition, hall, gridWidth, gridHeight, setGridWidth, setGridHeight,
      setGridData, setLayoutLoaded, setLayoutExistsOnServer, initializeGrid]);

  const saveLayout = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const layoutId = hall ? `${exhibition.id}_${hall.id}` : exhibition.id;
      const layoutData = {
        exhibition_id: layoutId,
        grid_width: gridWidth,
        grid_height: gridHeight,
        grid_data: gridData
      };

      if (layoutExistsOnServer) {
        await axios.put(`${API}/layouts/${layoutId}`, layoutData, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axios.post(`${API}/layouts`, layoutData, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setLayoutExistsOnServer(true);
      }
      toast.success('Kroki kaydedildi!');
    } catch (error) {
      toast.error('Kroki kaydedilemedi: ' + (error.response?.data?.detail || error.message));
    }
  }, [exhibition, hall, gridWidth, gridHeight, gridData, layoutExistsOnServer, setLayoutExistsOnServer]);

  return { loadLayout, saveLayout, initializeGrid };
}
